<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
         <div>
          <b-modal id="modal" :title="referralNote" ref="referral-modal">
            <div class="row">
              <div class="col-md-12">
                <p class="mb-3">{{ modalContent  }}</p>
              </div>
            </div>
          </b-modal>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Referrals</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <input class="form-control" type="text" name="search" id="search" placeholder="Search"
                                        v-model="serverParams.search" @keyup="searchItem()">
                                </div>
                                <div class="col-md-3">
                                </div>
                            </div>
                        </div>
                       <CircleLoader v-if="isLoading" />
                       <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            v-else
                            :totalRows="totalRecords" 
                            :pagination-options="{ enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], }"
                            :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'ReferralDate'">
                                    <span class="referral-link" @click="openReferralModal(props.row)">{{ props.row.ReferralDate ? dateFormat(props.row.ReferralDate) : '' }}</span>
                                </span>
                                <span v-if="props.column.field == 'FirstName'">
                                    <span>{{ props.row.FirstName }} {{ props.row.LastName }}</span>
                                </span>
                                <span v-if="props.column.field == 'ReferredBy'">
                                    <span> {{ props.row.RefFullname }}</span>
                                </span>

                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <!-- <toggle-button
                                
                                @change="changeStatus()"
                                :sync="true" color="#070708" class="mr-1"/> -->
                                    <b-button size="sm" @click="editReferrals(props.row)" class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                    <b-button v-if="props.row.MemberStatus == 'Active'" size="sm"
                                        @click="editMemberStatus(props.row.UserID)" class="mr-1 btn-danger text-white ">
                                        Suspended
                                    </b-button>
                                    <b-button v-if="props.row.MemberStatus != 'Active'" size="sm"
                                        @click="editMemberStatus(props.row.UserID)" class="mr-1 btn-danger text-white">
                                        Unsuspend
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue, { set } from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import moment from 'moment'

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            searchTime: null,
            isDisabled: false,
            referralNote: 'Referral Note',
            modalContent: '',
            selected: true,
            unSelected: false,
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'UserID', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Referral Date',
                    field: 'ReferralDate',
                    filterable: false,
                },
                {
                    label: 'Referee',
                    field: 'FirstName',
                    sortable: false,
                },
                {
                    label: 'Referrer',
                    field: "ReferredBy",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            ReferredBy: new Map(),
            form: {
                ReferredID: '',
            },
        };
    },
    methods: {
        editReferrals(Referrals) {
            this.$router.push({ name: 'edit_Referrals', params: { id: Referrals.UserID, user: Referrals } });
        },
        editMemberStatus(id) {
            this.form.ReferredID = id;
            this.editMemberStatuss();
        },
        openReferralModal(row) {
            this.modalContent = row.ReferralNotes;
            this.$refs['referral-modal'].show();
        },
        editMemberStatuss() {
            API.updateRefMemberStatus(this.form,
                data => {
                    this.isDisabled = false;
                    if (data.status === 200) {
                        this.$showNotification(data,"success")
                        this.loadItems();
                    } else {
                        this.errorMsg('Please try again.')
                    }
                },
                err => {
                    this.isDisabled = false;
                    this.errorMsg(err)
                }
            )
        },
        dateFormat(val) {
            return moment(val).format('DD MMMM YYYY')
        },
        loadItems() {
            API.getAllReferrals(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data.data;
                    this.isLoading = false;
                }, err => {
                    console.log(err)
                    this.isLoading = false;
                })
        },
        searchItem() {
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.loadItems()
            }, 500)
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({message:'Failed system error'},"error")
        }
    },
    computed: {}
    ,
    mounted() {
        this.isLoading = true;
        this.loadItems();
    }
}
</script>